import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { initSentry, APP_VERSION } from './lib/sentry'
import App from './App.tsx'
import { PostHogProvider } from 'posthog-js/react'

// Initialize Sentry BEFORE React renders
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
        debug: import.meta.env.MODE === 'development',
        // Register app version as a super property - sent with every event
        bootstrap: {
          featureFlags: {},
        },
        loaded: (posthog) => {
          posthog.register({
            app_version: APP_VERSION,
          })
        },
      }}
    >
      <App />
    </PostHogProvider>
  </StrictMode>,
)